import { GET_TENANT_PROPERTIES } from "../../actions/actionTypes";

export const tenantPropertiesReducer = (state=[], action) => {
    switch(action.type){
        case GET_TENANT_PROPERTIES:
            return action.payload.tenantProperty;
        default:
            return state;
        
    }
}